"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardDrop = void 0;
var tslib_1 = require("tslib");
var react_dnd_1 = require("react-dnd");
var basicDropCollect = function (monitor) { return ({
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
    item: monitor.getItem(),
}); };
var BasicDropCollectTypeWrapper = /** @class */ (function () {
    function BasicDropCollectTypeWrapper() {
        this.basicDropCollect = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return basicDropCollect.apply(void 0, tslib_1.__spread(args));
        };
    }
    return BasicDropCollectTypeWrapper;
}());
function useDashboardDrop(draggableItemTypes, specArg, deps) {
    return react_dnd_1.useDrop({
        accept: draggableItemTypes,
        drop: specArg.drop,
        canDrop: specArg.canDrop,
        collect: basicDropCollect,
        hover: specArg.hover,
    }, deps);
}
exports.useDashboardDrop = useDashboardDrop;
//# sourceMappingURL=useDashboardDrop.js.map